import { LogoStyle, LogoStyleLetter } from './Logo.styled';

const Logo = () => {
  return (
    <LogoStyle>
      pe
      <LogoStyleLetter>t</LogoStyleLetter>
      ly
    </LogoStyle>
  );
};

export default Logo;
